<div style="line-height: 1.4">
  <div class="expression-formula text-break text-wrap" [title]="expression?.Comments || ''" [attr.data-placeholder]="placeholder">
    {{expression?.Formula}}
  </div>
  <div class="expression-formula text-primary fst-italic text-break text-wrap" [title]="expression?.Comments || ''">
    {{expression?.ExternalFormula}}
  </div>

  <div class="expression-formula text-gray-300 fst-italic text-break text-wrap" *ngIf="expression.Formula == '' && expression.ExternalFormula == '' && expression.Comments != ''">
    {{expression?.Comments | shorten: 30: '...'}}
  </div>
</div>

